import { CustomerScreen } from '../features/customers/CustomerScreen'
import { useShell } from '../app/outlet'

export function CustomerPage() {
  const { toast } = useShell()
  return <CustomerScreen onToast={toast} />
}
